export class SyncFrequencyGuard {
    constructor(syncCallsThresholdPerMinute) {
        this.syncCallsThresholdPerMinute = syncCallsThresholdPerMinute;
        this.callsPerMinuteMap = new Map();
    }
    isSyncCallsThresholdReachedThisMinute() {
        const stringDateToTheMinute = this.getCallsPerMinuteKey();
        const persistedCallsCount = this.callsPerMinuteMap.get(stringDateToTheMinute) || 0;
        return persistedCallsCount >= this.syncCallsThresholdPerMinute;
    }
    incrementCallsPerMinute() {
        const stringDateToTheMinute = this.getCallsPerMinuteKey();
        const persistedCallsCount = this.callsPerMinuteMap.get(stringDateToTheMinute);
        const newMinuteStarted = persistedCallsCount === undefined;
        if (newMinuteStarted) {
            this.clear();
            this.callsPerMinuteMap.set(stringDateToTheMinute, 1);
        }
        else {
            this.callsPerMinuteMap.set(stringDateToTheMinute, persistedCallsCount + 1);
        }
    }
    clear() {
        this.callsPerMinuteMap.clear();
    }
    getCallsPerMinuteKey() {
        const now = new Date();
        return `${now.getFullYear()}-${now.getMonth()}-${now.getDate()}T${now.getHours()}:${now.getMinutes()}`;
    }
}
